import {
  FILTER_TYPES,
  FilterTypes,
  FormTabsTypes,
  SearchAndFilterTypes,
} from "src/constants";

const defaultFilters = [
  FilterTypes.School,
  FilterTypes.Tags,
  FilterTypes.Grades,
  FilterTypes.DynamicQuestions,
  FilterTypes.PreferredLanguage,
  FilterTypes.HasErrors,
  FilterTypes.IneligibleSchoolChoice,
  FilterTypes.Visibility,
  FilterTypes.AttendingSchool,
];

export const FiltersByTab: Record<string, string[]> = {
  [FormTabsTypes.Submissions]: [
    ...defaultFilters,
    FilterTypes.Status,
    FilterTypes.StatusDate,
    FilterTypes.SubStatus,
    FilterTypes.SubStatusDate,
    FilterTypes.ExpiresAtDate,
    FilterTypes.Rank,
    FilterTypes.VerificationStatus,
    FilterTypes.Badges,
  ],
  [FormTabsTypes.Waitlists]: [
    ...defaultFilters,
    FilterTypes.SubStatus,
    FilterTypes.SubStatusDate,
    FilterTypes.ExpiresAtDate,
    FilterTypes.WithinCapacity,
  ],
  [FormTabsTypes.Offers]: [
    ...defaultFilters,
    FilterTypes.SubStatus,
    FilterTypes.SubStatusDate,
    FilterTypes.ExpiresAtDate,
  ],
  [FormTabsTypes.All]: [
    ...defaultFilters,
    FilterTypes.Status,
    FilterTypes.StatusDate,
    FilterTypes.SubStatus,
    FilterTypes.SubStatusDate,
    FilterTypes.ExpiresAtDate,
    FilterTypes.SubmittedBefore,
    FilterTypes.Rank,
    FilterTypes.VerificationStatus,
  ],
  [FormTabsTypes.FormListImports]: [
    ...defaultFilters,
    FilterTypes.Status,
    FilterTypes.StatusDate,
    FilterTypes.Rank,
    FilterTypes.VerificationStatus,
  ],
  [FormTabsTypes.DropoffForms]: [
    FilterTypes.School,
    FilterTypes.Tags,
    FilterTypes.Status,
    FilterTypes.StatusDate,
    FilterTypes.SubStatus,
    FilterTypes.SubStatusDate,
    FilterTypes.ExpiresAtDate,
    FilterTypes.Grades,
    FilterTypes.DynamicQuestions,
    FilterTypes.Visibility,
  ],
};

export const verifyFilterInclusion = (
  searchParams: URLSearchParams,
  filter: FilterTypes
) =>
  FiltersByTab[
    searchParams.get(SearchAndFilterTypes.Tab) ?? FormTabsTypes.Submissions
  ]?.includes(filter);

export const countAppliedFilters = (searchParams: URLSearchParams) => {
  return Object.entries(FILTER_TYPES).reduce((acc, [filterType, settings]) => {
    const filterValue = searchParams.get(filterType) ?? "";
    if (typeof settings.count === "function") {
      return acc + settings.count(filterValue);
    }
    return (
      acc + (filterValue !== (settings.default ?? "") ? settings.count ?? 1 : 0)
    );
  }, 0);
};

export const verifyIfFiltersAreApplied = (searchParams: URLSearchParams) =>
  Object.entries(FILTER_TYPES).some(
    ([filterType, settings]) =>
      (searchParams.get(filterType) ?? "") !== (settings.default ?? "")
  );

export const clearFilters = (searchParams: URLSearchParams) => {
  Object.entries(FILTER_TYPES).forEach(([filterType, settings]) => {
    settings.default
      ? searchParams.set(filterType, settings.default)
      : searchParams.delete(filterType);
  });
};
